import React from "react";
import "./Team.css";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";

// Faculty Images
import i30 from "../Team/Team Images/Shubhi_Sharma.jpg";
import i31 from "../Team/Team Images/Sugandha_Sharma.jpg";

// Executive Committee Images
import anshExec from "../Team/Team Images/Ansh.jpg";
import deepanshuExec from "../Team/Team Images/Deepanshu_Miglani_Secretary.jpg";
import jiyaExec from "../Team/Team Images/JiyaBajaj.jpeg";
import keshavExec from "../Team/Team Images/KESHAV .jpg";
import manveeExec from "../Team/Team Images/Manvee Singh.JPG";

// Heads Images
import aakarsh from "../Team/Team Images/Aakarsh Garg_Associate VFX Head.jpg";
import aakritiDhawan from "../Team/Team Images/Aakriti Dhawan_Working Committee Head.jpg";
import aarushi from "../Team/Team Images/Aarushi Sharma_Associate PR Head.jpg";
import aasthik from "../Team/Team Images/Aasthik_Upadhyay_Joint_Secretary.jpg";
import abhas from "../Team/Team Images/Abhas_Jaiswal_Associate_Tech_Head.jpg";
import akash from "../Team/Team Images/Akash_chauhan_cinematography.jpg";
import anshShukla from "../Team/Team Images/Ansh Shukla _Associate PR head.jpg";
import arjun from "../Team/Team Images/Arjun Saroha_ Events Head.jpg";
import diptanshu from "../Team/Team Images/Diptanshu Banerjee_Technical Head.jpg";
import manya from "../Team/Team Images/Manya Arora_Associate Design Head_.jpg";
import mayank from "../Team/Team Images/Mayank Anand_Editor in Chief.jpeg";
import mohit from "../Team/Team Images/Mohit Jain__Photography Head.png";
import mudit from "../Team/Team Images/Mudit Singh Bora Associate event heads .JPG";
import raghvendra from "../Team/Team Images/Raghvendra_Associate VFX Head.jpg";
import rashika from "../Team/Team Images/Rashika-Sehgal_Design-Head.png";
import riya from "../Team/Team Images/Riya Joshi _ Social media head.jpg";
import shaurya from "../Team/Team Images/Shauryawaedhan_AssociateTreasurer.JPG";
import sheetal from "../Team/Team Images/Sheetal Bijalwan_ Associate Editor-in-Chief.jpg";
import vanshika from "../Team/Team Images/Vanshika Srivastava_Management and Record Head.jpg";
import viraj from "../Team/Team Images/Viraj Bhidola_ registrations head.JPG";
import yashIOH from "../Team/Team Images/Yash_IOH.jpg";
import saakshi from "../Team/Team Images/saakshi_associate registration head_.jpg";

import { FaLinkedin } from "react-icons/fa";
import Heading from "../../Components/Heading/Heading";

// Faculty Details
import shubhimam from './Team Details/Shubhimam';
import sughanda from './Team Details/Sughanda';

// Executive Details
import anshDetail from './Team Details/Ansh.js';
import deepanshuDetail from './Team Details/Deepanshu.js';
import jiyaDetail from './Team Details/Jiya.js';
import keshavDetail from './Team Details/Keshav.js';
import manveeDetail from './Team Details/Manvee.js';

// Heads Details
import aakarshDetail from './Team Details/Aakarsh.js';
import aakritiDetail from './Team Details/Aakriti.js';
import aarushiDetail from './Team Details/Aarushi.js';
import aasthikDetail from './Team Details/Aasthik.js';
import abhasDetail from './Team Details/Abhas.js';
import akashDetail from './Team Details/Akash.js';
import anshShuklaDetail from './Team Details/AnshShukla.js';
import arjunDetail from './Team Details/Arjun.js';
import diptanshuDetail from './Team Details/Diptanshu.js';
import manyaDetail from './Team Details/Manya.js';
import mayankDetail from './Team Details/Mayank.js';
import mohitDetail from './Team Details/Mohit.js';
import muditDetail from './Team Details/Mudit.js';
import raghvendraDetail from './Team Details/Raghvendra.js';
import rashikaDetail from './Team Details/Rashika.js';
import riyaDetail from './Team Details/Riya.js';
import shauryaDetail from './Team Details/Shaurya.js';
import sheetalDetail from './Team Details/Sheetal.js';
import vanshikaDetail from './Team Details/Vanshika.js';
import virajDetail from './Team Details/Viraj.js';
import yashIOHDetail from './Team Details/YashIOH.js';
import saakshiDetail from './Team Details/Saakshi.js';

const Team = () => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(shubhimam);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const [Faculty, setFaculty] = useState([
    {
      image: i30,
      name: "Shubhi Sharma",
      designation: "Student Branch Coordinator",
      button: shubhimam,
      http: "https://www.linkedin.com/in/shubhi-sharma-6443a322/"
    },
    {
      image: i31,
      name: "Sugandha Sharma",
      designation: "Faculty Coordinator",
      button: sughanda,
      http: "https://www.linkedin.com/in/sugandha-sharma-00001/"
    },
  ]);

  const [executives, setExecutives] = useState([
    {
      image: jiyaExec,
      name: "Jiya Bajaj",
      designation: "President",
      button: jiyaDetail,
      http: "https://www.linkedin.com/in/jiya-bajaj-439539259/"
    },
    {
      image: keshavExec,
      name: "Keshav Garg",
      designation: "Vice-President",
      button: keshavDetail,
      http: "https://www.linkedin.com/in/keshav-garg0709"
    },
    {
      image: manveeExec,
      name: "Manvee Singh",
      designation: "General Secretary",
      button: manveeDetail,
      http: "https://www.linkedin.com/in/manvee-singh-8842641b8"
    },
    {
      image: deepanshuExec,
      name: "Deepanshu Miglani",
      designation: "Secretary",
      button: deepanshuDetail,
      http: "https://www.linkedin.com/in/deepanshu-miglani-dsm"
    },
    {
      image: anshExec,
      name: "Ansh Garg",
      designation: "Director",
      button: anshDetail,
      http: "https://www.linkedin.com/in/ansh-garg-422950145"
    },
  ]);

  const [team, setTeam] = useState([
    {
      image: aasthik,
      name: "Aasthik Upadhyay",
      designation: "Joint Secretary",
      button: aasthikDetail,
      http: "https://www.linkedin.com/in/aasthik-upadhyay-0a5730213"
    },
    {
      image: aakritiDhawan,
      name: "Akriti Dhawan",
      designation: "Working Committee Head",
      button: aakritiDetail,
      http: "https://linkedin.com/in/aak23/"
    },
    {
      image: yashIOH,
      name: "Yash Sharma",
      designation: "Internal Operations Head",
      button: yashIOHDetail,
      http: "https://www.linkedin.com/in/yash28sharma"
    },
    {
      image: shaurya,
      name: "Shauryawardhan Mittal",
      designation: "Associate Treasurer",
      button: shauryaDetail,
      http: "https://www.linkedin.com/in/shauryawardhanmittal"
    },
    {
      image: anshShukla,
      name: "Ansh Shukla",
      designation: "Associate PR Head",
      button: anshShuklaDetail,
      http: "https://www.linkedin.com/"
    },
    {
      image: aarushi,
      name: "Aarushi Sharma",
      designation: "Associate PR Head",
      button: aarushiDetail,
      http: "https://www.linkedin.com/in/aarushi-sharma-096618289"
    },
    {
      image: rashika,
      name: "Rashika Sehgal",
      designation: "Design Head",
      button: rashikaDetail,
      http: "https://www.linkedin.com/in/rashikasehgal/"
    },
    {
      image: manya,
      name: "Manya Arora",
      designation: "Associate Design Head",
      button: manyaDetail,
      http: "https://www.linkedin.com/"
    },
    {
      image: mayank,
      name: "Mayank Anand",
      designation: "Editor-in-Chief",
      button: mayankDetail,
      http: "https://www.linkedin.com/in/mayank-anand-50b154287/"
    },
    {
      image: sheetal,
      name: "Sheetal Bijalwan",
      designation: "Associate Editor-in-Chief",
      button: sheetalDetail,
      http: "https://www.linkedin.com/in/sheetal-bijalwan-163899288"
    },
    {
      image: arjun,
      name: "Arjun Saroha",
      designation: "Events Head",
      button: arjunDetail,
      http: "https://www.linkedin.com/in/arjun-saroha-19ba22279"
    },
    {
      image: mudit,
      name: "Mudit Singh Bora",
      designation: "Associate Events Head",
      button: muditDetail,
      http: "https://www.linkedin.com/in/mudit-singh-bora-3686b6310"
    },
    {
      image: diptanshu,
      name: "Diptanshu Banerjee",
      designation: "Technical Head",
      button: diptanshuDetail,
      http: "https://www.linkedin.com/"
    },
    {
      image: abhas,
      name: "Abhas Jaiswal",
      designation: "Associate Technical Head",
      button: abhasDetail,
      http: "https://www.linkedin.com/"
    },
    {
      image: viraj,
      name: "Viraj Bhidola",
      designation: "Registration Head",
      button: virajDetail,
      http: "https://www.linkedin.com/in/viraj-bhidola-22aa69288/"
    },
    {
      image: saakshi,
      name: "Saakshi Tewari",
      designation: "Associate Registration Head",
      button: saakshiDetail,
      http: "https://www.linkedin.com/"
    },
    {
      image: vanshika,
      name: "Vanshika Srivastava",
      designation: "M&R Head",
      button: vanshikaDetail,
      http: "https://www.linkedin.com/in/vanshika-srivastava-71220a292"
    },
    {
      image: riya,
      name: "Riya Joshi",
      designation: "Social Media Head",
      button: riyaDetail,
      http: "https://www.linkedin.com/in/riya-joshi-a93b6b351"
    },
    {
      image: mohit,
      name: "Mohit Jain",
      designation: "Photography Head",
      button: mohitDetail,
      http: "https://www.linkedin.com/in/mohit-jain-32366b281"
    },
    {
      image: akash,
      name: "Akash Chauhan",
      designation: "Cinematography Head",
      button: akashDetail,
      http: "https://www.linkedin.com/in/akash-chauhan-3475b0299"
    },
    {
      image: raghvendra,
      name: "Raghvendra Goyal",
      designation: "Associate VFX Head",
      button: raghvendraDetail,
      http: "https://www.linkedin.com/in/raghvendra-goyal-250113299"
    },
    {
      image: aakarsh,
      name: "Aakarsh Garg",
      designation: "Associate VFX Head",
      button: aakarshDetail,
      http: "https://www.linkedin.com/in/aakarsh-garg-196817290/"
    },
  ]);
  const [hoveredIndex, setHoveredIndex] = useState(null); // Add this line

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <div className="our-team">
      <Heading head="Team UPES-CSI" size="50px"></Heading>
      <Heading head="Our Faculty" size="30px"></Heading>
      <div
        className="d-flex align-items-center justify-content-center custom-grid flex-wrap"
        style={{ placeItems: "center" }}
      >
        {Faculty.map((member, index) => (
          <div
            onClick={function () { onOpenModal(); setUser(member.button); }}
            style={{ cursor: "pointer" }}
            key={index}
            className={`team-member  p-4  bg-white shadow-md  ${hoveredIndex === index ? "hovered" : ""
              }`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="img ">
              <div className="img2">
                <div className="w-full">
                  <img
                    src={member.image}
                    alt="team"
                  />
                </div>
              </div>

              <div className="info text-left mt-2 flex items-center">
                <a
                  href={member.http}
                  className="z-10"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaLinkedin className="text-white mr-4 ml-2" size={40} />
                </a>
                <div>
                  <h3 className="text-xl font-semibold text-gray-100">
                    {member.name}
                  </h3>
                  <p className="text-gray-400">{member.designation}</p>
                </div>
              </div>
            </div>

          </div>
        ))}
      </div>
      
      <Heading head="Executive Committee" size="30px"></Heading>
      <div
        className="d-flex align-items-center justify-content-center flex-wrap custom-grid"
        style={{ placeItems: "center" }}
      >
        {executives.map((member, index) => (
          <div
            onClick={function () {
              onOpenModal();
              setUser(member.button);
            }}
            style={{ cursor: "pointer" }}
            key={index}
            className={`team-member  p-4 pb-3 bg-white shadow-md  ${hoveredIndex === index ? "hovered" : ""
              }`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="img">
              <div className="img2">
                <div className="w-full">
                  <img
                    src={member.image}
                    alt="team"
                  />
                </div>
              </div>

              <div className="info text-left mt-2 flex items-center">
                <a
                  href={member.http}
                  style={{ zIndex: "999" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaLinkedin
                    className="white linked mr-4 ml-2"
                    color="white"
                  />
                </a>
                <div>
                  <h3 className="text-xl font-semibold text-gray-100">
                    {member.name}
                  </h3>
                  <p className="text-gray-400">{member.designation}</p>
                </div>
              </div>
            </div>

          </div>
        ))}
      </div>
      
      <Heading head="Student Body" size="30px"></Heading>
      <div
        className="d-flex align-items-center justify-content-center flex-wrap custom-grid"
        style={{ placeItems: "center" }}
      >
        {team.map((member, index) => (
          <div
            onClick={function () {
              onOpenModal();
              setUser(member.button);
            }}
            style={{ cursor: "pointer" }}
            key={index}
            className={`team-member  p-4 pb-3 bg-white shadow-md  ${hoveredIndex === index ? "hovered" : ""
              }`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="img">
              <div className="img2">
                <div className="w-full">
                  <img
                    src={member.image}
                    alt="team"
                  />
                </div>
              </div>

              <div className="info text-left mt-2 flex items-center">
                <a
                  href={member.http}
                  style={{ zIndex: "999" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaLinkedin
                    className="white linked mr-4 ml-2"
                    color="white"
                  />
                </a>
                <div>
                  <h3 className="text-xl font-semibold text-gray-100">
                    {member.name}
                  </h3>
                  <p className="text-gray-400">{member.designation}</p>
                </div>
              </div>
            </div>

          </div>
        ))}
      </div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay2",
          modal: "customModal2",
        }}
      >
        <div className="container-fluid team-modal backdrop-saturate-125 justify-content-center gap-5 text-white">
          {user.info}
        </div>
      </Modal>
    </div>
  );
};

export default Team;
